import { clientGetWrapper, clientPostWrapper, clientStreamingPostWrapper } from "../api/Api";
import { AI_CHAT_STREAM, AI_CHAT_HISTORY } from "../common/constants/routes";

export const getAiChatResponse = (message) => {
    return clientPostWrapper(AI_CHAT_STREAM, { message });
};

export const getAiChatStreamResponse = (conversationId, messages) => {
    return clientStreamingPostWrapper(AI_CHAT_STREAM, {
        conversationId,
        messages
    });
};

export const getAiChatHistory = (offset = 0, limit = 10) => {
    return clientGetWrapper(AI_CHAT_HISTORY, { offset, limit });
};
